import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Formik } from 'formik';
import { RootState, useAppSelector, useAppDispatch, loadClients } from '../../../redux';
import { RoutineAction, Client } from '../../../models';
import { ClientSelectField } from '../../ClientSelectField';

interface AssignClientFormProps {
    action: RoutineAction;
    onSave?: (action: RoutineAction) => void;
}

function AssignClientForm(props: AssignClientFormProps) {
    const { action, onSave } = props;
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [options, setOptions] = useState<AnyObj>(action.options || {});
    const { clients } = useAppSelector((state: RootState) => state.clients);

    useEffect(() => { dispatch(loadClients()); }, [dispatch]);
    useEffect(() => { onSave && onSave({ ...action, options }); }, [options]);

    const selectedClient = useMemo(() => {
        if (!options.client)
            return undefined;
        return (clients || []).find((client: Client) => client._id === options.client);
    }, [clients, options.client]);

    return (
        <div className="grid grid-cols-1 xl:grid-cols-4 gap-2 bg-purple-50 dark:bg-purple-950/30 p-2 border rounded w-full">
            <label className="text-sm col-span-1">{t('projects.routine.action.change_client')}</label>
            <div className="col-span-3">
                <Formik
                    initialValues={{ client: selectedClient || null }}
                    enableReinitialize
                    onSubmit={() => {}}
                >
                    <ClientSelectField
                        name="client"
                        value={selectedClient}
                        placeholder={t('projects.routine.action.change_client') || ''}
                        onChange={(client?: Client) => setOptions({ ...options, client: client?._id })}
                        className="!mt-0"
                        selectedClassName="!bg-white dark:bg-gray-800 !text-gray-900 dark:text-gray-100"
                        searchInputClassName="!ring-gray-300 dark:ring-gray-600"
                    />
                </Formik>
            </div>
        </div>
    );
}

export default AssignClientForm;
